import { useNavigate } from "react-router-dom";

import type { ClientId } from "../domain/types";
import { CO_BASE, nextSlugAfter } from "../domain/steps";
import { flushPending, getClient, markDone } from "../data/store";

/**
 * Continue = flush any debounced edits, mark this sub-step done, then land on
 * the next applicable one (recomputed from the client's current answers, so
 * branching picks up choices made on this very screen).
 *
 * The flush is awaited before navigating. Without it a user who types in a
 * field and immediately hits Continue could out-run the debounce and lose the
 * last keystrokes.
 */
export function useSubStepNav(clientId: ClientId, slug: string) {
  const navigate = useNavigate();

  async function goNext() {
    await flushPending();

    const client = getClient(clientId);
    const next = client ? nextSlugAfter(client, slug) : undefined;

    await markDone(clientId, slug, next);

    if (next) {
      navigate(`${CO_BASE}/${clientId}/${next}`);
    } else {
      navigate(CO_BASE);
    }
  }

  return { goNext };
}
